import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { TrashIcon } from "@heroicons/react/solid";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";
import { initLightboxJS } from 'lightbox.js-react';
import { SlideshowLightbox } from 'lightbox.js-react'
import Resizer from 'react-image-file-resizer';
import { PDFDocument } from 'pdf-lib';
import Select from "react-select";
import { apiFetch } from '../utils/apiClient';

const FormulaireNom = ({ user }) => {
  const [isSubmitted, setIsSubmitted] = useState(false); // State to control popup
  const [message, setMessage] = useState("");
  const location = useLocation();
  let selectedForm = location.state?.selectedForm;
  const navigate = useNavigate(); // Initialize navigate hook
  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreviewUrl, setFilePreviewUrl] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [errors, setErrors] = useState({});
  const [couleur, setcouleur] = useState("");
  const [fileUploadError, setFileUploadError] = useState("");
  const [listeDocumentsNom, setlisteDocumentsNom] = useState([]);
  // const [open, setOpen] = useState(false);

  useEffect(() => {
        initLightboxJS("Insert_Your_License_Key_Or_Use_Default", "default");
      }, []);

  const base64ToFile = (base64, filename, mimeType) => {
    // Remove the base64 data prefix (if it exists)
    const base64String = base64.split(",")[1]; // Get the part after the comma
    if (!base64String) {
      throw new Error("Invalid base64 string");
    }

    // Decode the base64 string
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });

    return file;
  };

  const handleFileUpload = async (e) => {
    const MAX_FILE_SIZE_MB = 5;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // en octets

    const file = e.target.files[0];
    if (!file) return;

    const ALLOWED_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png"
];


if (!ALLOWED_TYPES.includes(file.type)) {
  setFileUploadError("Formats acceptés : PDF, JPG, JPEG, PNG.");
  return;
}

     // --- Resize image ---
  const resizeImage = (file) =>
    new Promise((resolve) => {
      if (!file.type.includes('image')) return resolve(file);

      Resizer.imageFileResizer(
        file,
        1600,          // maxWidth
        1600,          // maxHeight
        'WEBP',        // format
        70,            // qualité
        0,             // rotation
        (uri) => {
          const resizedFile = new File([uri], file.name, { type: 'image/webp' });
          resolve(resizedFile);
        },
        'blob',
        200,           // minWidth
        200            // minHeight
      );
    });

  // --- Compress PDF ---
  const compressPDF = async (file) => {
    if (file.type !== 'application/pdf') return file;

    const arrayBuffer = await file.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const compressedBytes = await pdfDoc.save(); // Re-encode
    const compressedFile = new File([compressedBytes], file.name, { type: 'application/pdf' });
    return compressedFile;
  };

  // --- Process file ---
  const processFile = async (file) => {
    if (file.type.includes('image')) {
      return await resizeImage(file);
    } else if (file.type === 'application/pdf') {
      return await compressPDF(file);
    }
    return file;
  };

  // --- Traitement ---
  const processedFile = await processFile(file);

  // --- Vérification après compression ---
  if (processedFile.size > MAX_FILE_SIZE) {
    setFileUploadError(
      `Le fichier (même après compression) dépasse ${MAX_FILE_SIZE_MB} Mo.`
    );
    return;
  }

   // --- Si taille OK ---
  setFileUploadError("");
  setUploadedFile(processedFile);
  setFilePreviewUrl(URL.createObjectURL(processedFile));

  const newFormData = {
    ...formData,
    uploadedFile: {
      filename: processedFile.name,
      contentType: processedFile.type,
      data: "", // backend will fill
    },
  };

  setFormData(newFormData);
  setErrors("");
    // setFormData({ ...formData, uploadedFile: file });
  };

  const handleFileDelete = () => {
    setUploadedFile(null); // Clear file state
    setFilePreviewUrl(null); // Clear file preview URL
    setShowPopup(false); // Close the popup if it's open

    // Directly clear the file input field
    const fileInput = document.getElementById("fileUpload");
    if (fileInput) {
      fileInput.value = ""; // Reset the file input's value
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-${yy}${mm}${dd}${randomNumber}-NOM`;
  };

  // const initialFormData = {
  //   userId: "",
  //   nom: "",
  //   numeroFormulaire: generateNumeroFormulaire(),
  //   courriel: "",
  //   nouveauNom: selectedForm?.nouveauNom || "",
  //   nouveauPrenom: selectedForm?.nouveauPrenom || "",
  //   dateEntreeEnVigueur: selectedForm?.dateEntreeEnVigueur || "",
  //   etatDemande: "En attente",
  //   traitant: {
  //     userId: "",
  //     nom: "",
  //     email: "",
  //   }, // Add the file property here
  //   uploadedFile: null,
  //   dateSoumission: "",
  // };

  const initialFormData = {
    userId: "",
    nom: "",
    numeroFormulaire: generateNumeroFormulaire(),
    courriel: "",
    nouveauNom: selectedForm?.nouveauNom || "",
    nouveauPrenom: selectedForm?.nouveauPrenom || "",
    deuxiemePrenom: selectedForm?.deuxiemePrenom || "",
    dateEntreeEnVigueur: selectedForm?.dateEntreeEnVigueur || "",
    etatDemande: "En attente",
    traitant: selectedForm?.traitant || [], // Add the file property here
    uploadedFile: null,
    dateSoumission: "",
  };

  // console.log("selected Form: ", selectedForm);
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        matricule: user.employeeId
      }));
    }

    if (selectedForm) {
      setFormData((prevData) => ({
        ...prevData,
        numeroFormulaire: selectedForm.numeroFormulaire, // Merge selectedForm data into formData
        documentJustificatif: selectedForm.documentJustificatif
      }));
      // console.log(selectedForm._id)
    }

    if (
      selectedForm?.uploadedFile?.data &&
      selectedForm?.uploadedFile?.contentType &&
      selectedForm?.uploadedFile?.filename
    ) {
      const base64String = `data:${selectedForm.uploadedFile.contentType};base64,${selectedForm.uploadedFile.data}`;
      const file = base64ToFile(
        base64String,
        selectedForm.uploadedFile.filename,
        selectedForm.uploadedFile.contentType
      );

      setUploadedFile(file);
      setFilePreviewUrl(URL.createObjectURL(file));
    }
  }, [user, selectedForm]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name === "nouveauPrenom" || name === "nouveauNom" || name === "deuxiemePrenom") {
      // Supprime tout sauf lettres, accents, espaces et tirets
      newValue = newValue.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s-]/g, "");

      // Tout mettre en minuscule
      newValue = newValue.toLowerCase();

      // Majuscule à chaque début de mot (après espace ou tiret aussi)
      newValue = newValue.replace(/(?:^|\s|-)([a-zà-öø-ÿ])/g, (match) =>
        match.toUpperCase()
      );
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
    setErrors("");
  };

  const handleFormAction = async (e, actionType) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    // Set the etatDemande based on the action type
    const updatedFormData = {
      ...formData,
      etatDemande: actionType, // Action type can be either "Soumettre" or "Enregistrer"
      dateSoumission: currentDate, // Send as a Date object
    };

    const method = location.state?.selectedForm ? "PUT" : "POST"; // Use PUT if selectedForm exists, otherwise POST
    const formType = "Nom";
    const url = location.state?.selectedForm
      ? `${process.env.REACT_APP_API_BASE_URL}/formFile/${location.state.selectedForm._id}?form=${formType}` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/formFile?form=${formType}`; // Use POST for creating a new form

    // console.log("uploadedFile : ", uploadedFile);

    const formDataToSend = new FormData();

    // Append form data fields to FormData (use JSON.stringify for nested objects if needed)
    formDataToSend.append("updatedFormData", JSON.stringify(updatedFormData));
    if (uploadedFile) {
      const blob = new Blob([uploadedFile], { type: uploadedFile.type });
      formDataToSend.append("file", blob, uploadedFile.name);
      // console.log(uploadedFile);
    }
    // Send the form data to the backend
    try {
      const response = await apiFetch(url, {
        method: method,
        body: formDataToSend,
      });

      if (response.ok) {
        setIsSubmitted(true); // Show popup
        // Hide popup after 3 seconds
        await new Promise((resolve) => {
          setTimeout(() => {
            setIsSubmitted(false); // Hide the popup after timeout
            resolve(); // Resolve the promise after 3 seconds
          }, 3000);
        });
        const initialFormData = {
          nom: user.displayName,
          userId: user.id,
          courriel: user.mail,
          numeroFormulaire: generateNumeroFormulaire(),
          nouveauNom: "",
          nouveauPrenom: "",
          dateEntreeEnVigueur: "",
          etatDemande: "En attente",
          // traitant: {
          //   userId: "",
          //   nom: "",
          //   email: "",
          // },
          traitant: [],
          dateSoumission: "",
        };
        handleFileDelete();
        setFormData(initialFormData);

        navigate("/demande", { state: { selectedForm: null } });

        // console.log(`Form data ${actionType.toLowerCase()} successfully!`);
      } else {
        console.error(`Failed to ${actionType.toLowerCase()} form data.`);
      }
    } catch (error) {
      console.error(`Error ${actionType.toLowerCase()} form data:`, error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return; // Stop if validation fails
    handleFormAction(e, "En attente");
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
    // setcouleur("text-green-600")
  };

  const handleSave = (e) => {
    handleFormAction(e, "Brouillon"); // Use "Enregistrer" for save action
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis."
    );
    setcouleur("text-grey-600");
    setErrors("");
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.nouveauNom.trim()) {
      newErrors.nouveauNom = "Le nouveau nom est obligatoire.";
    }
    if (!formData.nouveauPrenom.trim()) {
      newErrors.nouveauPrenom = "Le nouveau prénom est obligatoire.";
    }
    if (!uploadedFile) {
      newErrors.uploadedFile = "Le fichier est obligatoire.";
    }
    if (!formData.dateEntreeEnVigueur) {
      newErrors.dateEntreeEnVigueur = "La date est obligatoire.";
    }
    if (!formData.documentJustificatif) {
      newErrors.documentJustificatif = "Veuillez sélectionner un document justificatif";
    }
    // Add other validations if necessary

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p style={{ color: "red" }}>{errors[field]}</p>
    ) : null;
  };

  /************************** Handle Inputs *******************************/

  const handleClear = () => {
    // setFormData(initialFormData); // Réinitialise le formulaire à son état initial
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        nouveauNom: "",
        nouveauPrenom: "",
        deuxiemePrenom: "",
        dateEntreeEnVigueur: "",
        etatDemande: "En attente",
        dateSoumission: "",
      }));
    }
    setErrors("");
  };

  useEffect(() => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/listeDocumentsNomSchema`)
        .then((response) => response.json())
        .then((data) => setlisteDocumentsNom(data))
        .catch((error) => console.error("Error fetching funds:", error));
    }, []);

  /************************************************************************/

  return (
    <div className="min-h-screen p-8 bg-white rounded-lg shadow-lg">
      <form
        onSubmit={handleSubmit}
        className=" p-8 bg-gray-100 rounded-lg shadow-lg"
      >
        <h1 className="text-2xl font-bold mb-6 text-black">
          Formulaire changement de nom
        </h1>
        <div className="w-[60%] mb-6 p-4 bg-yellow-50 border-orange-500 text-orange-800 rounded-md flex items-start space-x-3">
  <svg
    className="w-6 h-6 flex-shrink-0 mt-1"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 19a7 7 0 100-14 7 7 0 000 14z" />
  </svg>
  <p className="text-sm sm:text-base">
    ⚠️ Aux membres de l'Ordre des Enseignants et des Enseignantes de l'Ontario : 
    veuillez d'abord mettre à jour votre nom auprès de l’ODE avant de soumettre une demande auprès du Conseil. 
    Assurez-vous que toutes vos informations sont exactes pour éviter tout retard dans le traitement de votre demande.
  </p>
</div>
        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
            <label
              htmlFor="nom"
              className="block text-sm font-medium text-blue-900"
            >
              Nom:
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>

          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="numeroFormulaire"
              className="block text-sm font-medium text-blue-900"
            >
              Numéro de formulaire:
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              name="numeroFormulaire"
              value={formData.numeroFormulaire}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>
        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Courriel :
            </label>
            <input
              type="text"
              id="courriel"
              name="courriel"
              value={formData.courriel}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Nouveau Nom<span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="nouveauNom"
              name="nouveauNom"
              value={formData.nouveauNom}
              onChange={handleChange}
              onKeyPress={(e) => {
                  const regex = /^[a-zA-ZÀ-ÿ-]$/; // lettres, accents et tirets seulement
                  if (e.key !== " " && !regex.test(e.key)) {
                    e.preventDefault(); // empêche la saisie si ce n'est pas valide
                  }
                }}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("nouveauNom")}
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Nouveau Prénom<span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="nouveauPrenom"
              name="nouveauPrenom"
              value={formData.nouveauPrenom}
              onChange={handleChange}
              onKeyPress={(e) => {
                  const regex = /^[a-zA-ZÀ-ÿ-]$/; // lettres, accents et tirets seulement
                  if (e.key !== " " && !regex.test(e.key)) {
                    e.preventDefault(); // empêche la saisie si ce n'est pas valide
                  }
                }}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("nouveauPrenom")}
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Deuxième prénom (optionnel) :
            </label>
            <input
              type="text"
              id="deuxiemePrenom"
              name="deuxiemePrenom"
              value={formData.deuxiemePrenom}
              onChange={handleChange}
              onKeyPress={(e) => {
                  const regex = /^[a-zA-ZÀ-ÿ-]$/; // lettres, accents et tirets seulement
                  if (e.key !== " " && !regex.test(e.key)) {
                    e.preventDefault(); // empêche la saisie si ce n'est pas valide
                  }
                }}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Choisir un document justificatif <span className="text-xl text-red-900" >*</span> :
            </label>
            <Select
            id="documentJustificatif"
            name="documentJustificatif"
            options={listeDocumentsNom.map((document) => ({
              value: document.name,
              label: String(document.name),
            }))}
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "documentJustificatif",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            placeholder="Sélectionner"
            value={
              formData.documentJustificatif
                ? { value: formData.documentJustificatif, label: String(formData.documentJustificatif) }
                : null
            }
            isClearable
            menuPlacement="auto"
            className="react-select-container"
            classNamePrefix="react-select"
            filterOption={(option, inputValue) =>
              option.label.toLowerCase().startsWith(inputValue.toLowerCase())
            }
          />
            {renderError("documentJustificatif")}
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5">
            <label
              htmlFor="fileUpload"
              className="block text-sm font-medium text-blue-900 mb-2"
            >
              Document<span className="text-xl text-red-900" >*</span> :
            </label>
            <div className="relative">
              <input
                type="file"
                id="fileUpload"
                name="fileUpload"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleFileUpload}
                className="absolute inset-0 opacity-0 cursor-pointer"
              />
              <button className="w-full px-4 py-2 border border-blue-500 rounded-lg text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 cursor-pointer">
                Choisir un fichier
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-1">
              Formats acceptés : PDF, JPG, JPEG, PNG.
            </p>
            {renderError("uploadedFile")}
            {fileUploadError && (
              <p style={{ color: "red", marginTop: "0.5rem" }}>
                {fileUploadError}
              </p>
            )}
          </div>
        </div>

        {/* File preview and actions */}
        {uploadedFile && (
          <div className="mt-3 w-3/4 flex items-center space-x-4">
            {/* View Document Button */}
            <p
              className="border rounded-lg px-4 py-2 w-[30%] bg-blue-900 text-white cursor-pointer inline-block hover:bg-blue-700 transition duration-200"
              onClick={() => setShowPopup(true)}
            >
              <span className="font-medium">Voir le document: </span>
              {uploadedFile.name}
            </p>

            {/* Delete File Button with Trash Icon */}
            <button
              onClick={handleFileDelete}
              className="w-10 h-10 border border-red-500 text-red-600 rounded-lg flex items-center justify-center transition duration-200"
            >
              <TrashIcon className="w-7 h-7" /> {/* Heroicons Trash Icon */}
            </button>
          </div>
        )}

        {/* Popup with file preview */}
        {showPopup && uploadedFile && (
          <>
            {/* Background overlay */}
            <div
              className="fixed  inset-0 bg-black bg-opacity-50 z-40"
              onClick={closePopup}
            ></div>

            {/* Centered popup */}
            <div className="fixed w-[60%] h-[80%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 bg-white border shadow-lg rounded-lg z-50">
              <div className="flex justify-between items-center">
                <div>
                          <h3 className="text-xl font-semibold text-gray-800">Aperçu du fichier</h3>
                          {uploadedFile.type.startsWith("image/") && (<p className="text-sm text-gray-500">Cliquez sur l’image pour l’agrandir</p>)}
                        </div>
                <button
                  onClick={closePopup}
                  className="text-gray-500 hover:text-gray-700 font-bold text-xl"
                >
                  X
                </button>
              </div>

              {/* Display preview based on file type */}
              {uploadedFile.type.startsWith("image/") && (
                // <>
                //   <img
                //     src={filePreviewUrl}
                //     alt="Aperçu"
                //     onClick={() => setOpen(true)}
                //     className="max-w-full max-h-[500px] rounded-lg mt-4 object-contain border cursor-pointer"
                //   />
                //   {open && (
                //     <Lightbox
                //       open={open}
                //       close={() => setOpen(false)}
                //       slides={[{ src: filePreviewUrl }]}
                //     />
                //   )}
                // </>
                <>
                              <SlideshowLightbox className="mx-auto">
                                <img
                                  src={filePreviewUrl}
                                  alt="Aperçu"
                                  className="max-w-full max-h-[500px] rounded-lg border cursor-zoom-in"
                                />
                              </SlideshowLightbox>
                          
                            </>
              )}

              {uploadedFile.type === "application/pdf" && (
                <iframe
                  src={filePreviewUrl}
                  title="PDF preview"
                  className="w-[100%] h-[90%] border mt-4"
                ></iframe>
              )}

              {!uploadedFile.type.startsWith("image/") &&
                !uploadedFile.type.includes("pdf") && (
                  <p className="text-sm text-gray-800 mt-4">
                    Preview not available for this file type.
                  </p>
                )}
            </div>
          </>
        )}

        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date d'entrée en vigueur<span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="date"
              id="dateEntreeEnVigueur"
              name="dateEntreeEnVigueur"
              value={formData.dateEntreeEnVigueur}
              onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("dateEntreeEnVigueur")}
          </div>
        </div>

        <div className="flex justify-start mt-4">
          {/* Left-aligned Buttons */}
          <div className="flex space-x-4">
            {/* Save Button */}
            {/* Reset Button */}
            <button
              type="button"
              onClick={handleClear}
              className="mt-5 w-24 py-2 bg-red-600 hover:bg-red-400 text-white rounded-md"
            >
              Réinitialiser
            </button>
            {selectedForm?.etatDemande !== "Rejeté" && (
              <button
                type="button"
                onClick={handleSave}
                className="mt-5 w-24 py-2 bg-gray-600 hover:bg-gray-400 text-white rounded-md"
              >
                Enregistrer
              </button>
            )}
            <button
              type="submit"
              className="mt-5 w-24 py-2 bg-green-600 text-white rounded-md hover:bg-green-400"
            >
              Soumettre
            </button>
          </div>

          {/* Right-aligned Submit Button */}
        </div>
      </form>

      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormulaireNom;
